module.exports = __webpack_public_path__ + "static/img/3.2a53640.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/sp/3.png
// module id = B206
// module chunks = 0